<template>
  <div>
    <vx-card>
    <div class="flex justify-end">
      <vs-button @click="$router.push({name:'org_management_cameras'})" color="danger" type="filled" icon-pack="feather" icon="icon-x" class="mr-4">Cancel</vs-button>
      <vs-button color="#009FB7" type="filled" icon-pack="feather" icon="icon-save" @click.prevent="updateCamera">Save</vs-button>
    </div>

    <div class="pt-8">
        <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/4 w-full">
        <span>Camera ID</span>
      </div>
      <div class="vx-col sm:w-3/4 w-full">
        <vs-input class="w-full" v-model="camID" disabled />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/4 w-full">
        <span>Camera Name</span>
      </div>
      <div class="vx-col sm:w-1/4 w-full">
        <vs-input class="w-full" type="text" v-model="name" disabled />
      </div>
      <div class="vx-col mt-6 md:mt-0 md:w-1/4 w-full md:pr-10 items-center md:flex md:justify-end">
        <span>Site</span>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-input class="w-full" type="text" v-model="site" disabled />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/4 w-full">
        <span>IP Address</span>
      </div>
      <div class="vx-col sm:w-1/4 w-full">
        <vs-input class="w-full" type="text" v-model="ipAddress" disabled />
      </div>
      <div class="vx-col md:w-1/4 w-full md:pr-10 items-center md:flex md:justify-end">
        <span>Area Bind</span>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-input class="w-full" type="text" v-model="areaBind" disabled />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/4 w-full">
        <span>Username</span>
      </div>
      <div class="vx-col sm:w-1/4 w-full">
        <vs-input class="w-full" type="text" v-model="username" />
      </div>
      <div class="vx-col md:w-1/4 w-full md:pr-10 items-center md:flex md:justify-end">
        <span>Password</span>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-input class="w-full" type="password" v-model="password" />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/4 w-full">
        <span>Event</span>
      </div>
      <div class="vx-col sm:w-1/4 w-full flex items-center">
        <vs-checkbox v-model="eventModel" vs-value="1">IN</vs-checkbox>
        <vs-checkbox v-model="eventModel" vs-value="2">OUT</vs-checkbox>
      </div>
    </div>
    <!-- <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/4 w-full">
        <span>Object</span>
      </div>
      <div class="vx-col sm:w-3/4 w-full flex items-center flex-wrap justify-between leading-loose">
        <vs-checkbox v-model="objectModel" vs-value="1">PERSON</vs-checkbox>
        <vs-checkbox v-model="objectModel" vs-value="2">CAR</vs-checkbox>
        <vs-checkbox v-model="objectModel" vs-value="3">MOTORCYCLE</vs-checkbox>
        <vs-checkbox v-model="objectModel" vs-value="4">OTHER</vs-checkbox>
      </div>
    </div> -->
    <div v-if="analyticsCodeView.length > 0" class="vx-row mb-6">
      <div class="vx-col sm:w-1/4 w-full">
        <span>Analytic Event Name</span>
      </div>
      <div class="vx-col sm:w-3/4 w-full">
        <div class="vx-row">
          <div v-for="(acv,k) in analyticsCodeView" :key="k" class="vx-col w-full flex items-center mb-3 sm:w-1/2">
            <input style="border: 1px solid rgba(0, 0, 0, 0.2)" class="w-full px-4 py-3 rounded-md" type="text" :value="acv" readonly/>
            <vs-button class="ml-4" color="success" type="filled" icon-pack="feather" icon="icon-copy" @click.prevent="copyAnalyticsCode(acv)">Copy</vs-button>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/4 w-full">
        &nbsp;
      </div>
      <div class="vx-col sm:w-3/4 w-full">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-grid" @click.prevent="showMoreEventModal = true">More Event</vs-button>
      </div>
    </div>
    </div>
  </vx-card>

  <Modal
      :show="showMoreEventModal"
      :order="2"
      size="lg"
      centered
      :close-by-backdrop="false"
      @close="closeMoreEventModal"
    >
    <div style="min-width: 900px;min-height: 500px;max-height: 700px;overflow-y: auto;" class="bg-white flex flex-col rounded">
        <div class="flex justify-between px-4 pt-4">
          <span class="text-lg font-bold uppercase">More Event ({{ name }})</span>
          <a @click.prevent="closeMoreEventModal" href="javascript:void(0)"><feather-icon icon="XIcon" /></a>
        </div>
        <div class="p-4">
          <MoreEventForm :areaBind="areaBind" :cameraName="camName" :name="name" />
        </div>
    </div>
  </Modal>
  </div>
</template>

<script>
  import api from "@/api";
  import Modal from "@/components/modal/Modal.vue";
  import MoreEventForm from './more_event.vue'
  export default {
    data() {
      return {
        id: '',
        camID: '',
        camName: '',
        name: '',
        areaBind: '',
        site: '',
        ipAddress: '',
        eventModel: [],
        objectModel: [],
        areaId: '',
        username: '',
        password: '',
        errorMessage: '',
        showMoreEventModal: false
      }
    },
    components: {Modal,MoreEventForm},
    computed: {
      analyticsCode() {
        let inOut = ''
        if(this.inArray('1', this.eventModel) && !this.inArray('2', this.eventModel)) {
          inOut = '[+]'
        }
        if(!this.inArray('1', this.eventModel) && this.inArray('2', this.eventModel)) {
          inOut = '[-]'
        }
        if(this.inArray('1', this.eventModel) && this.inArray('2', this.eventModel)) {
          inOut = '[+][-]'
        }
        return `[IS]${inOut}[${this.areaBind}][${this.name}]`
      },
      analyticsCodeView() {
        let result = []
        this.eventModel.map(e => {
          let inOut = ''
          if(e == '1') {
            inOut = '[+]'
          } else if (e == '2') {
            inOut = '[-]'
          }
          result.push(`[IS]${inOut}[${this.areaBind}][${this.name}]`)
        })
        return result
      }
    },
    mounted() {
      const cam = this.$store.state.currentCamera
      console.log("🎬 [mounted] Current camera data:", cam)
      
      if (cam && Object.keys(cam).length > 0) {
        this.id = cam.id
        this.camID = cam.camId
        this.camName = cam.camName
        this.name = cam.name
        this.areaBind = cam.areaName
        this.site = cam.siteName
        this.ipAddress = cam.ipAddress
        this.eventModel = cam.eventType ? String(cam.eventType).split(',').filter(e => e) : []
        this.objectModel = cam.objectCode ? String(cam.objectCode).split(',').filter(e => e) : []
        this.areaId = cam.areaId
        this.username = cam.username || ""
        this.password = cam.password || ""
        this.statusId = cam.statusId || 1
      }
    },
    methods: {
      inArray(needle, haystack) {
        var length = haystack.length;
        for(var i = 0; i < length; i++) {
            if(haystack[i] == needle) return true;
        }
        return false;
      },
      updateCamera() {
        this.$vs.loading()
        api.updateCamera({
          id: this.id,
          camId: this.camID,
          camName: this.camName,
          name: this.name,
          ipAddress: this.ipAddress,
          eventType: this.eventModel != null ? this.eventModel.join(',') : '',
          objectCode: this.eventModel != null ? this.objectModel.join(',') : '',
          eventCode: this.analyticsCode,
          areaId: this.areaId,
          username: this.username,
          password: this.password,
          statusId: this.statusId,
        })
        .then((result) => result.data)
        .then((data) => {
            this.$vs.loading.close()
            if(!data.status) {
                this.$vs.notify({
                    title:'Error',
                    text: data.message,
                    color:'danger',
                    position:'bottom-center'
                })
            } else {
                this.$vs.notify({
                    title:'Success',
                    text:'Success update camera',
                    color:'success',
                    position:'bottom-center'
                })
                setTimeout(() => {
                  this.$router.push({name:'org_management_cameras'})
                },500)
            }
        })
        .catch((e) => {
            console.log(e)
            this.$vs.loading.close()
        });
      },
      copyAnalyticsCode(valName) {
        this.copyToClipboard(valName)

        this.$vs.notify({
            title:'Success',
            text:'Analytic Event Name has been copy to clipboard',
            color:'success',
            position:'bottom-center'
        })
      },
      copyToClipboard(text) {
          var dummy = document.createElement("textarea");
          // to avoid breaking orgain page when copying more words
          // cant copy when adding below this code
          // dummy.style.display = 'none'
          document.body.appendChild(dummy);
          //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
          dummy.value = text;
          dummy.select();
          document.execCommand("copy");
          document.body.removeChild(dummy);
      },
      closeMoreEventModal() {
        this.showMoreEventModal = false
      }
    }
  }
</script>